export const replaceAllAcemptuation = (string) => {
    return string.toLowerCase()
    .replace(/ç/gm, 'c')
    .replace(/[áàäãâ]/gm, 'a')
    .replace(/[èéëê]/gm, 'e')
    .replace(/[ìíïî]/gm, 'i')
    .replace(/[òóôöõ]/gm, 'o')
    .replace(/[üùúû]/gm, 'u')
}